import React, { createContext, FC, useContext } from "react";
import { IContextData } from "../types/Context";

const AppContext = createContext<IContextData>({
  isBootstrapped: false,
  feedStatus: "idle",
  galleryStatus: "idle",
  recentFeed: [],
  homepageFeed: [],
  gallery: {
    workCompleted: [],
    equipmentRepairs: [],
    outdoorSports: [],
    videos: [],
    playgrounds: [],
  },
});

export const useAppDataContext = () => useContext(AppContext);

export const AppDataContext: FC<{
  children: React.ReactNode;
  contextData: IContextData;
}> = ({ children, contextData }) => {
  return (
    <AppContext.Provider value={contextData}>{children}</AppContext.Provider>
  );
};
